// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"805":"8227e08ae1af00c6","915":"61b1afca5db6ce63"}[chunkId] + ".js";
};